export default [
  {
    path: '/topicDesc',
    name: '消费券定向发放解决方案',
    component: () => import('../views/topicPages/topicDesc')
  },
  {
    path: '/topicYH',
    name: '储值贸易平台',
    component: () => import('../views/topicPages/topicYH')
  },
  {
    path: '/topicZX',
    name: '全面推进乡村振兴战略',
    component: () => import('../views/topicPages/topicZX')
  },
  {
    path: '/topicSY',
    name: '腾信智慧溯源展销系统',
    component: () => import('../views/topicPages/topicSY')
  },
  {
    path: '/topicFC',
    name: '塞外丰川',
    component: () => import('../views/topicPages/topicFC')
  }
]



// WEBPACK FOOTER //
// ./src/router/topicRoutes.js